export class API {
  public static prodBaseURL = "https://absli-uat-api.clevernav.ai";
}
